<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import tipoProdutoService from '@/src/services/api-receituario/tipo-produto'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading},
  data() {
    return {
      mostraForm: true,
      tipoEdit: {},
      tipos: [],
      tipoSelect: [],
      tipoFields: [        
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
        },        
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      idProduto: '',
      filter: '',
      rows: 0,
    }
  },
  computed: {},

  watch: {
    mostraForm() {
      if (this.mostraForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
  },
  methods: {
    listando() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      tipoProdutoService.listar(token)
        .then((resposta) => {
          this.tipos = resposta.data.tipos
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    cadastra() {
      if (this.mostraForm === true) {
        this.tipoEdit = {}
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    editRegister(tipo) {
      this.tipoEdit = tipo
      this.mostraForm = false
    },
    salvar() {
      const token = this.$store.state.auth.currentUser.token
      if (this.tipoEdit.id) {
        this.isLoading = true
        tipoProdutoService.update(token, this.tipoEdit)
          .then((resposta) => {
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })            
            this.isLoading = false            
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = false
          })
      } else {
        this.isLoading = true
        tipoProdutoService.salvar(token, this.tipoEdit)
          .then((resposta) => {
            this.isLoading = false
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.tipoEdit = {}
          })
          .catch((erro) => {
            this.isLoading = false
            this.$bvToast.toast(
              erro.response ? erro.response.data.data : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          })
      }
    },
    modalDelete(item) {
      this.$bvModal.show('modal-delete')
      this.idUserDelete = item
    },
    handleDelete() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      tipoProdutoService.deletar(token, this.idUserDelete)
        .then((reposta) => {
          this.isLoading = false
          this.listando()
        })
        .catch((err) => {
          this.$bvModal.hide('modal-delete')
          this.isLoading = false
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.$bvModal.hide('modal-delete')
      this.idUserDelete = null
      this.isLoading = false
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Tipo de Produto</div>
            <div class="subTitulo">
              Registre os Tipo de produtos aqui.
            </div>
          </div>
          <div class="col-md-2">
            <div class="float-right">
              <button class="btn btn-primary" @click="cadastra">
                <span v-if="mostraForm">Novo</span>
                <span v-else>Visualizar Tipos</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div class="row" v-if="mostraForm">
         <div class="col-md-4">
          <b-form-group id="input-group-1" label="Descrição" label-for="filter">
            <b-form-input
              id="filter"
              v-model="filter"
              type="text"
              placeholder="Digite o filtro de busca"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div v-if="mostraForm">
        <b-table
          striped
          hover
          responsive="sm"
          borderless
          bordered
          outlined
          small
          :items="tipos"
          :fields="tipoFields"
          :per-page="perPage"
          :filter="filter"
          show-empty
        >
          <template #empty="scope">
            <div class="row">
              <div class="col-md-12">
                <span>Nenhum tipo de produto encontrado!</span>
              </div>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="btn-group mb-2">
              <button
                v-b-tooltip.hover
                title="Editar"
                type="button"
                class="btn btn-light"
                @click="editRegister(row.item)"
              >
                <i class="uil uil-edit"></i>
              </button>
              <button
                v-b-tooltip.hover
                title="Deletar"
                type="button"
                class="btn btn-light"
                @click="modalDelete(row.item.id)"
              >
                <i class="uil uil-trash-alt"></i>
              </button>
            </div>
          </template>
          <template v-slot:cell(ativo)="row">{{
            row.item.ativo ? 'Sim' : 'Não'
          }}</template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          size="md"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>

      <div v-else>
        <b-form>
          <div class="row">
            <div class="col-8">
              <div class="row">
                <div class="col">
                  <b-form-group label="Descrição">
                    <b-form-input v-model="tipoEdit.nome" />
                  </b-form-group>
                </div>                
              </div>
            </div>
            <div class="row">
              <div class="col"> </div>
            </div>
          </div>
          <b-button type="submit" variant="primary" @click.prevent="salvar"
            >Salvar</b-button
          >
        </b-form>
      </div>
    </div>

    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="primary" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>